interface HeaderProps {
    label: string;
    description?: string;
}

export const Header = ({ label, description }: HeaderProps) => {
    return (
        <div className="flex w-full flex-col items-center justify-center gap-y-4 text-center">
            <h1 className="text-3xl font-semibold">
                {label}
            </h1>
            <p className="text-sm text-muted-foreground">{description}</p>
        </div>
    );
};